import ThemeProvider from "./Layout/ThemeProvider";
import AllRoutes from "./Routes/AllRoutes";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { fetchMe } from "./ReduxStore/App/auth.slice";
import { Toaster } from "react-hot-toast";
export default function App() {

  const dispatch = useDispatch();

  useEffect(() => { dispatch(fetchMe()) }, [dispatch])
  return (
    <>
      <div>
        <Toaster position="top-center" />
        <AllRoutes />
      </div>
    </>
  );
}
